import {
  AnalyticsProps,
  NOT_TRACKED_CONTENT,
} from '../../InternalLibrary/analytics';
import { default as DigitalCodeInput } from 'components/atoms/DigitalCodeInput/DigitalCodeInput';
import {
  default as FieldGroup,
  FieldGroupProps,
} from 'components/atoms/FieldGroup/FieldGroup';
import { InputProps } from 'components/atoms/Input/Input';
import { useCallback, useEffect } from 'react';
import { useFormik } from 'formik';
import { useValidationText } from 'hooks/useValidationText';
import TextInputEvent from '../../hooks/eventCollector/events/TextInputEvent';
import useEventCollector from '../../hooks/eventCollector/useEventCollector';

export interface DigitalCodeInputActorProps extends AnalyticsProps {
  className?: string;
  classNameFieldGroup?: string;
  digitalCodeInputProps?: Partial<InputProps>;
  fieldGroupProps?: Omit<FieldGroupProps, 'children'>;
  formik: ReturnType<typeof useFormik<any>>;
  onChange?: () => void;
  name: string;
  value?: string;
}

export const DigitalCodeInputActor: React.FC<DigitalCodeInputActorProps> = ({
  className,
  classNameFieldGroup,
  formik,
  onChange: onChangeFromParent,
  name,
  fieldGroupProps = {},
  digitalCodeInputProps = {},
  analytics,
}) => {
  const { track } = useEventCollector();

  const onChange = useCallback(
    (e: any) => {
      formik.status?.errors?.[name] && delete formik.status.errors[name];
      formik.handleChange(e);
      if (onChangeFromParent) onChangeFromParent();
    },
    [formik, name, onChangeFromParent],
  );

  useEffect(() => {
    if (analytics?.dontTrack) {
      return;
    }

    track(
      new TextInputEvent({
        description: analytics?.description,
        value: NOT_TRACKED_CONTENT,
      }),
    );
  }, [
    analytics?.contentOverride,
    analytics?.description,
    analytics?.dontTrack,
    analytics?.dontTrackContent,
    formik.values,
    track,
  ]);

  return (
    <FieldGroup
      className={classNameFieldGroup}
      validationText={useValidationText(formik, name)}
      {...fieldGroupProps}
    >
      <DigitalCodeInput
        inputClassName={className}
        values={formik.values}
        name="verificationCode"
        onChange={onChange}
        {...digitalCodeInputProps}
      />
    </FieldGroup>
  );
};
